module.exports = __webpack_public_path__ + "media/steps/carq_spinner_3-7741a861.png";